<template>
<div>
    <div class="right-title">
      <span>候选人推荐排名</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <div>
          <el-dropdown class="project-container" trigger="click" @command="choiceRegion">
            <span class="el-dropdown-link">
               {{address?address:'切换城市'}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu class="project-dropdown" slot="dropdown">
              <el-dropdown-item v-for="item in region" :key="item.id" :command="item.id">{{item.categoryname}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
       <div>
         <el-button class="btn2" @click="smonth=1" :class="{active:smonth === 1}" style="margin-right: 10px;">当月</el-button>
         <el-button class="btn2" @click="smonth=2" :class="{active:smonth === 2}" style="margin-right: 10px;">上月</el-button>
         <el-input
           class="search"
           type="text"
           placeholder="请输入ID/姓名"
           v-model="search"
         >
         </el-input>
         <el-button class="btn2" @click="keyWord" type="primary" style="margin-left: 10px;">搜索</el-button>
       </div>

      </div>
      <div class="tab-box">
        <el-table
                ref="multipleTable"
                :data="list"
                tooltip-effect="dark"
                style="width: 100%;height: 100%"
                :header-cell-style="{background: '#f2f3f5',color: '#000;'}"
        >
<!--          <el-table-column-->
<!--                  prop="tj_id"-->
<!--                  label="ID"-->
<!--                  align="center"-->
<!--          >-->
<!--          </el-table-column>-->
          <el-table-column
                  prop="recommend_user_name"
                  label="姓名"
                  align="center"
          >
          </el-table-column>
          <el-table-column
                  prop="count"
                  label="推荐的次数"
                  align="center"
                  sortable
          >
<!--            <template slot-scope="scope">-->
<!--              <span style="cursor: pointer" @click="toDetail(scope.row.resume_id)">{{scope.row.count}}</span>-->
<!--            </template>-->
          </el-table-column>
          <el-table-column
                  prop="cgcount"
                  label="推荐成功的次数"
                  sortable
                  align="center"
          >
          </el-table-column>
        </el-table>
<!--        <div class="page-box">-->
<!--          <div></div>-->
<!--          <el-pagination-->
<!--                  background-->
<!--                  @size-change="handleSizeChange"-->
<!--                  @current-change="handleCurrentChange"-->
<!--                  :current-page.sync="page.pageNum"-->
<!--                  :page-size="page.pageSize"-->
<!--                  layout="prev, pager, next, jumper"-->
<!--                  :total="page.pageTotal">-->
<!--          </el-pagination>-->
<!--        </div>-->
      </div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "hxrPaiming",
    data() {
      return {
        search: '',  // 搜索
        region: [],
        tableData: [],
        smonth:1,   //1 当月   2 上个月
        sheng:'',
        address:'',
        page:{
          pageNum:1,
          pageSize:10 ,
          pageTotal:1
        },
      }
    },
    computed: {
      list(){
        let _list = JSON.parse(JSON.stringify(this.tableData))
        _list.map(item => {
          //推荐
          item.jinzhituijian = item.jinzhituijian === 1 ? (true) : (false)
        })
        return _list
      },
      user(){
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 3)
      this.paimingList()
      this.$api.apiContent.region({
        admin_id:this.user.id
      })
        .then(res => {
          this.region = res.data
          if(this.$route.query.sheng) {
            this.sheng = this.$route.query.sheng*1
            this.region.map(item=>{
              if(item.id === this.sheng){
                this.address  = item.categoryname
              }
            })
          }else{
            this.address  = this.region[0].categoryname
            this.sheng  = this.region[0].id
          }

        }).catch()
    },
    methods: {

      //  选择省份执行的方法
      choiceRegion(command) {
        this.region.map(item => {
          if (item.id === command) {
            this.address = item.categoryname
            this.sheng = command
          }
        })
      },
      paxu2(param){
        console.log(param)
      },


      toDetail(id){
        this.$router.push({
          path:'/home/hxrAdmin/hxrResume',
          query:{
            resumeId:id
          }
        })
      },
      // 简历排名列表
      paimingList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if(this.$route.query.pageNum){
          this.page.pageNum = Number(this.$route.query.pageNum)
        }else {
          this.page.pageNum = 1
        }
        if(this.$route.query.key){
          this.search =this.$route.query.key
        }else {
          this.search = ''
        }
        if(this.$route.query.smonth){
          this.smonth =this.$route.query.smonth*1
        }else {
          this.smonth = 1
        }
        if(this.$route.query.sheng){
          this.sheng =this.$route.query.sheng*1
        }else {
          this.sheng = ''
        }
        this.$api.apiContent.hxrPaim2({
          search:this.search,
          page:this.page.pageNum,
          pageSize:this.page.pageSize,
          smonth:this.smonth,
          sheng:this.sheng,
          admin_id:this.user.id
        }).then(res => {
           loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          this.tableData = res.data

        }).catch(() => {
           loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },

      handleSizeChange(num){        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num){     //  选择页数
        this.page.pageNum = num
      },
      keyWord() {     //  搜索
        if(this.page.pageNum === 1){
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },

      //  修改路径
      setPath(){
        this.$router.push({
          path:'/home/hxrAdmin/hxrPaiming2',
          query:{
            pageNum:this.page.pageNum,
            key:this.search,
            smonth:this.smonth,
            sheng:this.sheng,
          }
        })
      },
    },
    watch: {
      'page.pageNum'(){
        this.setPath()
      },
      smonth(){
        this.setPath()
      },
      sheng(){
        this.setPath()
      },
      $route(){
        this.paimingList()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: space-between;


    .search {
      width: 220px;
      /*position: absolute;*/
      /*right: 80px;*/
      /*border-radius: 4px !important;*/
    }
    div{
      display: flex;
      span{
        display: block;
        line-height: 40px;
        font-size: 16px;
        margin: 0 10px;
        cursor: pointer;
      }
    }
    .btn7 {
      color: #333;
      &.active{
        color: #00a2ea;
      }
    }
    .btn30 {

      color: #333;
      &.active{
        color: #00a2ea;
      }
    }
    .btn90 {
      color: #333;
      &.active{
        color: #00a2ea;
      }
    }
  }
  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    /*padding-bottom: 60px;*/
    background: #fff;


    .page-box{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .el-dropdown-link {
    color: #333;
  }
  .btn2.active{
    background: #00a2ea;
    color: #fff;
  }
</style>